/**
 * API configuration
 *
 * In deployed builds, VITE_API_URL is injected at build time via Vite's
 * import.meta.env mechanism. In local development, it falls back to localhost:3000.
 */

declare const __GIT_SHA__: string;

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const CLIENT_VERSION = __GIT_SHA__;
